// Core
import React from 'react';

// Components
import {
  Paragraph,
  ParagraphSize,
  ParagraphWeight,
} from '../../layout/elements/Paragraph';

// Component
import {
  ModuleIFMItem,
  ModuleIFMLayout,
  ModuleIFMProps,
  ModuleIFMStatus,
} from './ModuleIFM.types';
import {
  CentralValue,
  Container,
  ItemsContainer,
  ItemsContent,
  LeftSection,
  CenterSection,
  RightSection,
  Status,
  StatusRight,
} from './ModuleIFM.style';

function ModuleIFM({
  centralValue,
  className,
  items,
  layout = ModuleIFMLayout.row,
  testId,
}: ModuleIFMProps): JSX.Element {
  // Dependencies
  const isColumn: boolean = layout === ModuleIFMLayout.column;

  // Filter items with even indices (starting from index 0 in the slice)
  const filteredItems: ModuleIFMItem[] = items.slice(2).filter((_, index) => index % 2 === 0);

  return (
    <Container
      className={className}
      data-testid={testId}
      isVertical={isColumn}
    >
      <ItemsContainer>
        <ItemsContent>
          <LeftSection>
            <Status status={items[0]?.status || ModuleIFMStatus.neutral} />
            <Paragraph size={ParagraphSize.sm} weight={ParagraphWeight.medium}>
              {items[0]?.text}
            </Paragraph>
          </LeftSection>

          <CenterSection>
            <CentralValue>
              <Paragraph size={ParagraphSize.sm} weight={ParagraphWeight.medium}>
                {centralValue}
              </Paragraph>
            </CentralValue>
          </CenterSection>

          <RightSection>
            <Paragraph size={ParagraphSize.sm} weight={ParagraphWeight.medium}>
              {items[1]?.text}
            </Paragraph>
            <StatusRight status={items[1]?.status || ModuleIFMStatus.neutral} />
          </RightSection>
        </ItemsContent>

        {/* Render the items with even indices */}
        {filteredItems.map((currentItem: ModuleIFMItem, index: number) => {
          const nextItemIndex: number = index * 2 + 3; // Calculate correct index in original array
          const nextItem: ModuleIFMItem | undefined = items[nextItemIndex];

          return (
            <ItemsContent key={`row-${currentItem.id}`}>
              <LeftSection>
                <Status status={currentItem.status} />
                <Paragraph size={ParagraphSize.sm} weight={ParagraphWeight.medium}>
                  {currentItem.text}
                </Paragraph>
              </LeftSection>

              <CenterSection />

              <RightSection>
                {nextItem ? (
                  <>
                    <Paragraph size={ParagraphSize.sm} weight={ParagraphWeight.medium}>
                      {nextItem.text}
                    </Paragraph>
                    <StatusRight status={nextItem.status} />
                  </>
                ) : (
                  <StatusRight status={ModuleIFMStatus.neutral} />
                )}
              </RightSection>
            </ItemsContent>
          );
        })}
      </ItemsContainer>
    </Container>
  );
}

export { ModuleIFM };
